import { instance as axios } from '../http'
import { ITEMS } from '../endpoints'

const getItems = id => axios.get(`${ITEMS}/${id}`)

export default {
  getItems
}



// WEBPACK FOOTER //
// ./src/repository/api/items.js